import { inject, Injectable } from '@angular/core';
import { ApiService } from '@core/auth/auth.service';
import { config } from '@core/interfaces/api_baseurl';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillPayServicesService {
  _ApiService: ApiService = inject(ApiService);
  _BillerOpratorListData = new BehaviorSubject<any>(null);
  _ValidateUserData = new BehaviorSubject<any>(null);
  _BillParams = new BehaviorSubject<any>(null);
  _ReceiptData = new BehaviorSubject<any>(null)
  constructor() { }

  getBillerCategory() {
    return this._ApiService.post(config.bbps.getBillerCatogryList, {});
  }
  getBillerOpratorList(payLoad: any) {
    return this._ApiService.post(config.bbps.getBillerOpratorList, payLoad)
  }
  getFetchBillData() {
    return this._BillerOpratorListData
  }
  getValidates(payLoad: any) {
    return this._ApiService.post(config.bbps.getValidate, payLoad)
  }
  getValidateInitialData() {
    return this._ValidateUserData;
  }
  getInitiateBillPayment(payLoad: any) {
    return this._ApiService.post(config.bbps.getInitiateBillPayment, payLoad)
  }
  getBillParams() {
    return this._BillParams;
  }
  getReceiptData() {
    return this._ReceiptData;
  }
  // generatePDF(
  //   _invoiceElement: any,
  //   filename: any,
  //   isType: 'PRINT' | 'DOWNLOAD' = 'DOWNLOAD',
  //   customPage?: boolean
  // ): void {
  //   let invoiceElement = _invoiceElement;
  //   html2canvas(invoiceElement, {
  //     useCORS: true,
  //     scale: 3,
  //     onclone(document: Document, element: HTMLElement) {
  //       element.querySelector('.receiptStampBox')?.classList.remove('d-none');
  //     },
  //   }).then((canvas) => {
  //     const imageGeneratedFromTemplate = canvas.toDataURL('image/png');
  //     const imgWidth = 210; // A4 width in mm
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width; // Adjust height proportionally

  //     let PDF = new jsPDF('p', 'mm', 'a4');
  //     let position = 0;
  //     let pageHeight = PDF.internal.pageSize.height;

  //     // *Handle multi-page PDFs*
  //     if (imgHeight > pageHeight) {
  //       let y = 0;
  //       while (y < imgHeight) {
  //         PDF.addImage(
  //           imageGeneratedFromTemplate,
  //           'PNG',
  //           5,
  //           y * -1, // Shift image upward on each new page
  //           imgWidth - 10,
  //           imgHeight
  //         );
  //         y += pageHeight;
  //         if (y < imgHeight) {
  //           PDF.addPage();
  //         }
  //       }
  //     } else {
  //       PDF.addImage(imageGeneratedFromTemplate, 'PNG', 5, position, imgWidth - 10, imgHeight);
  //     }

  //     if (isType == 'DOWNLOAD') {
  //       PDF.save(`${filename}.pdf`);
  //     } else if (isType == 'PRINT') {
  //       PDF.autoPrint();
  //       window.open(PDF.output('bloburl'), '');
  //     }
  //   });
  // }

  generatePDFq(
    _invoiceElement: any,
    filename: any,
    isType: 'PRINT' | 'DOWNLOAD' = 'DOWNLOAD',
    customPage?: boolean
  ): void {
    let invoiceElement = _invoiceElement;

    html2canvas(invoiceElement, {
      useCORS: true,
      scale: 3,
      onclone(document: Document, element: HTMLElement) {
        element.querySelector('.receiptStampBox')?.classList.remove('d-none');
      },
    }).then((canvas) => {
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const padding = 5; // Top & Bottom padding in mm
      const contentHeight = pageHeight - padding * 2; // Usable content height

      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let y = 0;

      let PDF = new jsPDF('p', 'mm', 'a4');

      while (y < imgHeight) {
        let canvasPart = document.createElement('canvas');
        let ctx = canvasPart.getContext('2d');
        let partHeight = Math.min(contentHeight, imgHeight - y);

        canvasPart.width = canvas.width;
        canvasPart.height = (partHeight * canvas.width) / imgWidth;

        if (ctx) {
          ctx.drawImage(
            canvas,
            0,
            (y * canvas.height) / imgHeight, // Source Y position
            canvas.width,
            canvasPart.height,
            0,
            0,
            canvas.width,
            canvasPart.height
          );

          let imgData = canvasPart.toDataURL('image/png');

          if (y > 0) {
            PDF.addPage();
          }

          PDF.addImage(imgData, 'PNG', 5, padding, imgWidth - 10, partHeight);
        }

        y += partHeight;
      }

      if (isType == 'DOWNLOAD') {
        PDF.save(`${filename}.pdf`);
      } else if (isType == 'PRINT') {
        PDF.autoPrint();
        window.open(PDF.output('bloburl'), '');
      }
    });
  }

  generatePDF(
    _invoiceElement: any,
    filename: any,
    isType: 'PRINT' | 'DOWNLOAD' = 'DOWNLOAD',
    customPage?: boolean
  ): void {
    let invoiceElement = _invoiceElement;

    html2canvas(invoiceElement, {
      useCORS: true,
      scale: 3,
      onclone(document: Document, element: HTMLElement) {
        element.querySelector('.receiptStampBox')?.classList.remove('d-none');
      },
    }).then((canvas) => {
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 297; // A4 height in mm
      const padding = 10; // Top & Bottom padding in mm
      const contentHeight = pageHeight - padding * 2; // Usable content height

      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let y = 0;

      let PDF = new jsPDF('p', 'mm', 'a4');

      while (y < imgHeight) {
        let canvasPart = document.createElement('canvas');
        let ctx = canvasPart.getContext('2d');
        let partHeight = Math.min(contentHeight, imgHeight - y);

        canvasPart.width = canvas.width;
        canvasPart.height = (partHeight * canvas.width) / imgWidth;

        if (ctx) {
          ctx.drawImage(
            canvas,
            0,
            (y * canvas.height) / imgHeight, // Source Y position
            canvas.width,
            canvasPart.height,
            0,
            0,
            canvas.width,
            canvasPart.height
          );

          let imgData = canvasPart.toDataURL('image/png');

          if (y > 0) {
            PDF.addPage();
          }

          PDF.addImage(imgData, 'PNG', 5, padding, imgWidth - 10, partHeight);
        }

        y += partHeight;
      }

      if (isType === 'DOWNLOAD') {
        PDF.save(`${filename}.pdf`);
      } else if (isType === 'PRINT') {
        const printBlob = PDF.output('bloburl'); // Convert PDF to blob URL
        const printWindow = window.open(printBlob, '_blank'); // Open in a new tab

        if (printWindow) {
          printWindow.onload = () => {
            printWindow.print(); // Auto-trigger print
          };
        }
      }
    });
  }



}
